import { createBrowserWorker, createConversionDriver, type ConversionDriver } from '../../workers/local/client';

let driver: ConversionDriver | null = null;

/**
 * 单例 Worker 驱动：所有本地转换共用同一个 Worker 与串行队列，
 * 避免并发解码把内存打满；惰性创建，保证在不支持 Worker 的环境（如单测）只需不调用即可。
 */
export function getConversionDriver(): ConversionDriver | null {
  if (typeof Worker === 'undefined') return null;
  if (!driver) driver = createConversionDriver(createBrowserWorker);
  return driver;
}

export function disposeConversionDriver(): void {
  driver?.dispose();
  driver = null;
}
